import React, { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../Pagination";

const DeletedStudyKitMetadata = ({
  tableRef,
  onMouseDown,
  deletedStudySiteKitMeta,
  softDeleteRestoreEIWRSKitMetadata,
  Show,
  Hide,
  Title,
  pageNumberDeleted,
  itemsPerPageDeleted,
  deletedStudySiteKitMetaCount,
  getDeletedEIWRSKitMetadataData,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(
    deletedStudySiteKitMetaCount / itemsPerPageDeleted
  );
  useEffect(() => {
    getDeletedEIWRSKitMetadataData(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 700 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {deletedStudySiteKitMetaCount === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 182px)" }}
            >
              <NoDataFoundTable MSG={"Kit metadata not deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Colum Label</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Colum Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Colum Type</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>is Unique</th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 5)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deletedStudySiteKitMeta?.map((item, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{item?.columnLabel}</td>
                      <td>{item?.columnName}</td>
                      <td className="text-capitalize">{item?.columnType}</td>
                      <td className="text-capitalize">{item?.isUnique}</td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreEIWRSKitMetadata(
                              item?._id,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={deletedStudySiteKitMetaCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedStudyKitMetadata;
